import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { LogSelectComponent } from '../../../../shared/component/log-select/log-select.component';
import { TableComponent } from '../../../../shared/component/table/table.component';
import { DestroyableComponent } from '../../../../shared/services/destroyable.component';
import { LogsPaginationService } from '../log-table/logs-pagination.service';

export interface LogConfig {
  header: string;
  logKey: string;
  orderBy?: string;
  downloadHeader?: string;
  showLocation?: boolean;
  showDaterange?: boolean;
  DateTimerange?: boolean;
  Date_Time?: boolean;
  Date_time?: boolean;
  timeDuration?: number;
  showSingleDate?: boolean;
  SingleLocationDropdown?: boolean;
  ShowLocationDropdown?: boolean;
  AllSelection?: boolean;
  showappliances?: boolean;
  FromToLocation?: boolean;
  showSites?: boolean;
  SiteOnly?: boolean;
  Nolocation?: boolean;
  MultiSites?: boolean;
  AllSites?: boolean;
  showsubtype?: boolean;
  showBillNo?: boolean;
  Month_Year?: boolean;
  Month_Range?: boolean;
  Date_Flat?: boolean;
  Hours?: boolean;
  search?: boolean;
  dropdown?: boolean;
  dropdownOptions?: any;
  placeholder?: any;
  InputField?: boolean;
  InputFields?: any[];
  tableLocation?: boolean;
  filterConfig?: any[];
  [key: string]: any;
}

@Component({
  selector: 'app-unified-log',
  standalone: true,
  imports: [TableComponent, CommonModule, LogSelectComponent],
  templateUrl: './unified-log.component.html',
  styleUrl: './unified-log.component.scss'
})
export class UnifiedLogComponent extends DestroyableComponent implements OnInit, OnDestroy {
  showtable = false;
  totalCount = 0;
  configLoaded = false;

  config: LogConfig = {
    header: '',
    logKey: '',
  };

  constructor(
    private logService: LogsPaginationService,
    private route: ActivatedRoute,
    private http: HttpClient
  ) {
    super();
  }

  ngOnInit(): void {
    this.logService.reset();
    this.route.url.pipe(takeUntil(this.destroy$)).subscribe((segments) => {
      // Derive config key from the last segment e.g. logs/dg_running → "dg_running"
      const logId = segments.length > 0 ? segments[segments.length - 1].path : null;
      this.configLoaded = false;
      if (logId) {
        this.http.get<any>('assets/log-configs.json').subscribe({
          next: (configs) => {
            if (configs && configs[logId]) {
              this.config = { ...this.config, ...configs[logId] };
            }
            this.configLoaded = true;
          },
          error: (err) => {
            console.error('Failed to load log configs', err);
            this.configLoaded = true;
          }
        });
      }
    });

    this.logService.showTable$
      .pipe(takeUntil(this.destroy$))
      .subscribe((v) => (this.showtable = v));

    this.logService.totalCount$
      .pipe(takeUntil(this.destroy$))
      .subscribe((c) => (this.totalCount = c));
  }

  // 🔹 Filter submit — payload passed as-is from log-select
  handleFilters(payload: any) {
    this.logService.initFilters(
      payload,
      this.config.logKey,
      this.destroy$,
      this.config.orderBy ?? '',
      this.config.downloadHeader ?? this.config.header
    );
  }

  // 🔹 Pagination
  handlePageChange(event: { page: number; pageSize: number }) {
    this.logService.changePage(event, this.destroy$);
  }

  // 🔹 Reset
  override ngOnDestroy(): void {
    this.handlereset(false);
  }

  handlereset(show: boolean) {
    if (!show) {
      this.logService.reset();
    }
  }
}
